@if(popupOpen) {
<milestone-edition-popup (onSave)="savePopup($event)" />
} @else {
<sliding-panel class="sliding-panel-payment-calendar-edition" [exit]="exit">
	<div class="top-section">
		<!-- Header -->
		<div class="header">
			<div class="title-section">
				<div
					class="dot"
					[ngClass]="{
						tpp1: _milestone?.group === 'TPP1',
						tpp2: _milestone?.group === 'TPP2',
						tpp3: _milestone?.group === 'TPP3',
						tpp4: _milestone?.group === 'TPP4',
						net: _milestone?.group === 'NETS'
					}"
				></div>
				<div class="text">
					@if(_milestone?.type !== 'NETS') {
					<span>GROUP</span>
					}
					<span>
						{{ _milestone?.group }} -
						{{ _milestone! | milestoneTypes | uppercase }}
					</span>
				</div>
			</div>

			<div class="cta-container">
				<ng-template [appUserRolePermissions] [action]="'hide'" [roles]="['TS_VO', 'CLIENT']">
					<div class="reset-button" id="resetButton" (click)="resetAll()" aria-hidden="true">Reset all</div>
				</ng-template>
				<div class="close-button" id="closeButton" (click)="cancel(false)" aria-hidden="true">
					<app-icon
						[name]="'close'"
						[color]="'var(--color-text-default)'"
						[size]="'45'"
						[lineWidth]="'1px'"
					></app-icon>
				</div>
			</div>
		</div>

		@if(milestoneDate) {
		<app-legal-entity-timezone-disclaimer
			[milestoneDate]="milestoneDate"
			[payGroup]="payGroup()!"
			[textMessage]="'Your calendar events will be set in your local time zone'"
		/>
		}

		<!-- Form -->
		<div class="form-container">
			@if(eventForm && showBookingDate) {
			<!-- Title netBookingDate -->
			<div class="title-form">Set booking date</div>

			<!-- Inputs netBookingDate -->
			<div class="inputs-container o-grid-2 full-width" [formGroup]="eventForm">
				<input-wrapper label="Date">
					<mat-form-field appearance="outline" (click)="picker.open()">
						<mat-datepicker-toggle matPrefix [for]="picker">
							<app-icon
								matDatepickerToggleIcon
								class="icon-payments"
								[name]="'calendar_month'"
								[color]="'var(--color-primary-1000)'"
							></app-icon>
						</mat-datepicker-toggle>
						<input
							id="netBookingDate"
							formControlName="netBookingDate"
							matInput
							[matDatepicker]="netBookingPicker"
							readonly
							[attr.data-test]="'net-booking-edit-selected-date'"
						/>
						@if(!eventForm.get('netBookingDate')?.value) {
						<mat-label>Select a booking date</mat-label>
						}
						<mat-datepicker
							#netBookingPicker
							(opened)="openDatePicker('booking-date')"
							(viewChanged)="datePickerViewChange($event, 'booking-date')"
						></mat-datepicker>
					</mat-form-field>
				</input-wrapper>
				<input-wrapper label="Time (UTC)">
					<div class="div-time-container flex flex-row">
						<app-icon class="icon-time" [name]="'clock-1'" [color]="'var(--color-primary-1000)'"></app-icon>
						<input
							id="netBookingTime"
							type="time"
							formControlName="netBookingTime"
							placeholder="Time"
							[attr.data-test]="'net-booking-edit-selected-time'"
						/>
					</div>
				</input-wrapper>
			</div>
			}

			<!-- Title -->
			<div class="title-form">{{ setDateTitle }}</div>

			<!-- Inputs -->
			@if(eventForm) {
			<div class="inputs-container o-grid-2 full-width" [formGroup]="eventForm">
				<!-- Pay date offset -->
				<input-wrapper readonly [label]="_milestone?.type === 'NETS' ? 'Pay date' : 'Pay date offset'">
					<mat-form-field appearance="outline" (click)="picker.open()">
						<mat-datepicker-toggle matPrefix [for]="picker">
							<app-icon
								matDatepickerToggleIcon
								class="icon-payments"
								[name]="'calendar_month'"
								[color]="'var(--color-primary-1000)'"
							></app-icon>
						</mat-datepicker-toggle>
						<input
							id="date"
							formControlName="date"
							matInput
							[matDatepicker]="picker"
							[attr.data-test]="
								_milestone!.group + '-' + (_milestone! | milestoneTypes) + '-edit-selected-date'
									| lowercase
							"
							readonly
						/>
						<mat-datepicker
							#picker
							(opened)="openDatePicker(_milestone!.group.toLowerCase() + '-booking-date')"
							(viewChanged)="
								datePickerViewChange($event, _milestone!.group.toLowerCase() + '-booking-date')
							"
						></mat-datepicker>
					</mat-form-field>

					@if(eventForm.controls.date.errors?.required) {
					<div input-errors>Event time is required</div>
					}
				</input-wrapper>

				<!-- Event time -->
				<input-wrapper label="Event time (UTC)">
					<div class="div-time-container flex flex-row">
						<app-icon class="icon-time" [name]="'clock-1'" [color]="'var(--color-primary-1000)'"></app-icon>

						<input
							id="time"
							type="time"
							formControlName="time"
							placeholder="Event time"
							[attr.data-test]="
								_milestone!.group + '-' + (_milestone! | milestoneTypes) + '-edit-selected-time'
									| lowercase
							"
						/>
					</div>

					@if(eventForm.controls.time.errors?.required) {
					<div input-errors>Event time is required</div>
					}
				</input-wrapper>
			</div>
			}
		</div>
	</div>

	<!-- CTA -->
	<ng-template [appUserRolePermissions] [action]="'hide'" [roles]="['TS_VO', 'CLIENT']">
		<div class="cta-container">
			<button
				id="cancelButton"
				class="cancel-button"
				action-buttons
				mat-stroked-button
				(click)="cancel(false)"
				[attr.data-test]="
					_milestone?.group + '-' + (_milestone! | milestoneTypes) + '-edit-cancel-button' | lowercase
				"
			>
				Cancel
			</button>
			<button
				id="saveButton"
				class="save-button"
				action-buttons
				mat-flat-button
				color="dark"
				(click)="save()"
				[disabled]="!eventForm?.valid || !canEdit"
				[attr.data-test]="
					_milestone?.group + '-' + (_milestone! | milestoneTypes) + '-edit-save-button' | lowercase
				"
			>
				Save
			</button>
		</div>
	</ng-template>
</sliding-panel>
}
